import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { fetchTimesheetReportDropdowns, fetchTimesheetMonthlyReport } from "store/actions";
import { useAuthUserDetails, } from "components/Common/getAuthUserDetails";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import toast from "react-hot-toast";



const SelectcustomStyles = {
  control: (base) => ({ ...base, minHeight: 33.1, height: 33.1 }),
  dropdownIndicator: (base) => ({ ...base, padding: "2px 8px" }),
  clearIndicator: (base) => ({ ...base, padding: "2px 8px" }),
  valueContainer: (base) => ({ ...base, padding: "0px 8px" }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
};

const TimesheetReportMonthlyTimesheet = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState("");
  const [projectOptions, setProjectOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [taskTypeOptions, setTaskTypeOptions] = useState([]);
  const [taskNatureOptions, setTaskNatureOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [appStatusOptions, setAppStatusOptions] = useState([]);
  const [authDetails, setAuthDetails] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const { timesheetReportDropdowns, monthlyReport } = useSelector((state) => ({
    timesheetReportDropdowns: state.TimesheetReportsReducer?.reportDropdowns,
    monthlyReport: state.TimesheetReportsReducer?.monthlyReport,
  }));

  const toggle = useCallback((id) => {
    setOpen(prev => prev === id ? "" : id);
  }, []);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    const user_id = authUserDetails[0].user_id
    const formData = new FormData();
    formData.append("unit_id", unitId);
    dispatch(fetchTimesheetReportDropdowns(formData));
  }, [dispatch]);

  useEffect(() => {
    if (timesheetReportDropdowns) {
      // Map client list
      if (timesheetReportDropdowns.client_list) {
        const clients = timesheetReportDropdowns.client_list.map(client => ({
          label: client.client_name,
          value: client.client_id
        }));
        setClientOptions(clients);
      }

      // Map project list
      if (timesheetReportDropdowns.project_list) {
        const projects = timesheetReportDropdowns.project_list.map(project => ({
          label: project.project_name,
          value: project.project_id
        }));
        setProjectOptions(projects);
      }

      // Map task type list
      if (timesheetReportDropdowns.time_tasktype) {
        const taskTypes = timesheetReportDropdowns.time_tasktype.map(taskType => ({
          label: taskType.task_type,
          value: taskType.tasktype_id
        }));
        setTaskTypeOptions(taskTypes);
      }

      // Map task nature list
      if (timesheetReportDropdowns.time_tasknatures) {
        const taskNatures = timesheetReportDropdowns.time_tasknatures.map(nature => ({
          label: nature.task_nature,
          value: nature.task_nature_id
        }));
        setTaskNatureOptions(taskNatures);
      }

      // Map task status list
      if (timesheetReportDropdowns.time_taskstatus) {
        const statuses = timesheetReportDropdowns.time_taskstatus.map(status => ({
          label: status.status_name,
          value: status.status_id
        }));
        setStatusOptions(statuses);
      }

      // Map app status list
      if (timesheetReportDropdowns.appStatus_list) {
        const appStatuses = timesheetReportDropdowns.appStatus_list.map(appStatus => ({
          label: appStatus.appstatus_name,
          value: appStatus.appstatus_id
        }));
        setAppStatusOptions(appStatuses);
      }
    }
  }, [timesheetReportDropdowns]);

  const fetchReportData = (filterValues = {}) => {
    if (!authDetails) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("emp_id", "0");
    formData.append("emp_code", filterValues.employeeCode || "0");
    formData.append("client_id", filterValues.client || "0");
    formData.append("project_id", filterValues.project || "0");
    formData.append("task_type_id", filterValues.taskType || "0");
    formData.append("task_nature_id", filterValues.taskNature || "0");
    formData.append("task_status_id", filterValues.status || "0");
    formData.append("app_status", filterValues.appStatus || "0");

    if (filterValues.month) {
      const date = new Date(filterValues.month);
      formData.append("month", date.toISOString().split("T")[0]);
      formData.append("unit_id", authDetails.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(fetchTimesheetMonthlyReport(formData));
    } else {
      setReportData([]);
      setLoading(false);
    }
  };


  const formik = useFormik({
    initialValues: {
      month: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      project: "",
      employeeCode: "",
      client: "",
      taskType: "",
      taskNature: "",
      status: "",
      appStatus: "",
    },
    validationSchema: Yup.object({
      month: Yup.string().nullable().required("Month is required"),
    }),
    onSubmit: (values) => {
      fetchReportData(values);
    },
  });


  // Update report data when API response changes
  useEffect(() => {
    console.log('monthlyReport:', monthlyReport);
    if (monthlyReport) {
      const data = monthlyReport.data || monthlyReport || [];
      console.log('Setting reportData:', data);
      setReportData(data);
      setLoading(false);
      setCurrentPage(0);
    }
  }, [monthlyReport]);

  console.log('Current reportData:', reportData);
  console.log('Current loading:', loading);

  // Transform API data for table display
  const transformedData = reportData.map((item, index) => ({
    sno: item.s_no || index + 1,
    date: item.t_date,
    project: `${item.client_name}${item.project}`,
    module: item.module_name,
    task: item.task_name,
    type: item.task_type,
    nature: item.task_nature,
    description: item.task_description,
    status: item.task_status,
    createdBy: item.create_by,
    createdOn: item.created_dt,
    allocatedHours: item.allocated_hours,
    workedHours: typeof item.worked_hours === 'string' ? item.worked_hours.replace(/\n/g, '').trim() : item.worked_hours,
    approvedHours: typeof item.approved_hours === 'string' ? item.approved_hours.replace(/\n/g, '').trim() : item.approved_hours,
    approvalStatus: item.task_approval_status,
    approvedBy: item.approved_by || item.rejected_by || item.cancelled_by || "",
    approvedOn: item.approved_dt || item.rejected_dt || item.cancelled_dt || "",
    approvalRemarks: item.approved_remarks || item.rejected_reason || item.cancelled_reason || "",
  }));

  const columns = [
    { Header: "Date", accessor: "date" },
    { Header: "Project", accessor: "project" },
    { Header: "Module", accessor: "module" },
    { Header: "Task", accessor: "task" },
    { Header: "Type", accessor: "type" },
    { Header: "Nature", accessor: "nature" },
    { Header: "Description", accessor: "description" },
    { Header: "Task Status", accessor: "status" },
    { Header: "Created By", accessor: "createdBy" },
    { Header: "Created On", accessor: "createdOn" },
    { Header: "Allocated Hours", accessor: "allocatedHours", Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value || '-'}</div> },
    { Header: "Worked Hours", accessor: "workedHours", Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value || '-'}</div> },
    { Header: "Approved Hours", accessor: "approvedHours", Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value || '-'}</div> },
    { Header: "Approval Status", accessor: "approvalStatus" },
    { Header: "Billable", accessor: "billable_hours", Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value || '-'}</div> },
    { Header: "Non Billable", accessor: "nonbillable_hours", Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value || '-'}</div> },
    { Header: "Approved / Rejected By", accessor: "approvedBy" },
    { Header: "Approved / Rejected On", accessor: "approvedOn" },
    { Header: "Approved / Rejected Remarks", accessor: "approvalRemarks" },
  ];

  const groupedData = useMemo(() => {
    return reportData.reduce((acc, item) => {
      const empKey = `${item.emp_name} - ${item.emp_no}`;
      if (!acc[empKey]) {
        acc[empKey] = {
          employee: item.emp_name,
          empNo: item.emp_no,
          dates: {}
        };
      }

      const dateKey = item.t_date;
      if (!acc[empKey].dates[dateKey]) {
        acc[empKey].dates[dateKey] = [];
      }

      acc[empKey].dates[dateKey].push(item);
      return acc;
    }, {});
  }, [reportData]);


  // Calculate totals for each employee
  const calculateTotals = useCallback((employeeData) => {
    let totalWorked = 0;
    let totalApproved = 0;

    Object.values(employeeData.dates).forEach(dateItems => {
      dateItems.forEach(item => {
        const workedHours = typeof item.worked_hours === 'string' ? item.worked_hours.replace(/\n/g, '').trim() : item.worked_hours;
        const approvedHours = typeof item.approved_hours === 'string' ? item.approved_hours.replace(/\n/g, '').trim() : item.approved_hours;
        const worked = parseFloat(workedHours.split(':')[0]) || 0;
        const approved = parseFloat(approvedHours.split(':')[0]) || 0;
        let DurationMins = 0, workedMins = 0;
        if (approvedHours) {
          let [hours, mins] = approvedHours.split(':').map(Number);
          DurationMins = (hours || 0) * 60 + (mins || 0);
        }

        if (workedHours) {
          let [hours, mins] = workedHours.split(':').map(Number);
          workedMins = (hours || 0) * 60 + (mins || 0);
        }

        totalWorked += workedMins;
        totalApproved += DurationMins;
      });
    });

    const mins = totalApproved;
    const hours = Math.floor(mins / 60);
    const remainingMins = mins % 60;
    const result = `${String(hours).padStart(2, '0')}:${String(remainingMins).padStart(2, '0')}`;

    const wmins = totalWorked;
    const whours = Math.floor(wmins / 60);
    const wremainingMins = wmins % 60;
    const wresult = `${String(whours).padStart(2, '0')}:${String(wremainingMins).padStart(2, '0')}`;
    return {

      workedHours: (wresult),
      approvedHours: (result)
    };
  }, []);

  // Calculate date totals
  const calculateDateTotals = useCallback((dateItems) => {
    let totalWorked = 0;
    let totalApproved = 0;

    dateItems.forEach(item => {
      const workedHours = typeof item.worked_hours === 'string' ? item.worked_hours.replace(/\n/g, '').trim() : item.worked_hours;
      const approvedHours = typeof item.approved_hours === 'string' ? item.approved_hours.replace(/\n/g, '').trim() : item.approved_hours;
      const worked = parseFloat(workedHours.split(':')[0]) || 0;
      const approved = parseFloat(approvedHours.split(':')[0]) || 0;
      totalWorked += worked;
      totalApproved += approved;
    });

    return {
      workedHours: `${totalWorked.toFixed(0).padStart(2, '0')}:00`,
      approvedHours: `${totalApproved.toFixed(0).padStart(2, '0')}:00`
    };
  }, []);

  // Pagination for employees using TableContainer logic
  const totalEmployees = Object.keys(groupedData).length;
  const totalPages = Math.ceil(totalEmployees / pageSize);
  const startIndex = currentPage * pageSize;
  const endIndex = startIndex + pageSize;
  const currentEmployees = Object.entries(groupedData).slice(startIndex, endIndex);

  const canPreviousPage = currentPage > 0;
  const canNextPage = currentPage < totalPages - 1;

  const gotoPage = (page) => setCurrentPage(page);
  const nextPage = () => canNextPage && setCurrentPage(currentPage + 1);
  const previousPage = () => canPreviousPage && setCurrentPage(currentPage - 1);
  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(0);
  };
  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const handleExportExcel = () => {
    if (!Array.isArray(reportData) || reportData.length === 0) {
      toast.error("No data to export.");
      return;
    }
    const exportData = reportData.map((item, index) => ({
      "Employee Code": item.emp_no,
      "Employee Name": item.emp_name,
      "Date": item.t_date,
      "Project": `${item.client_name}${item.project}`,
      "Module": item.module_name,
      "Task": item.task_name,
      "Type": item.task_type,
      "Nature": item.task_nature,
      "Description": item.task_description,
      "Task Status": item.task_status,
      "Created By": item.create_by,
      "Created On": item.created_dt,
      "Allocated Hours": item.allocated_hours,
      "Worked Hours": typeof item.worked_hours === 'string' ? item.worked_hours.replace(/\n/g, '').trim() : item.worked_hours,
      "Approved Hours": typeof item.approved_hours === 'string' ? item.approved_hours.replace(/\n/g, '').trim() : item.approved_hours,
      "Approval Status": item.task_approval_status,
      "Approved / Rejected By": item.approved_by || item.rejected_by || item.cancelled_by || "",
      "Approved / Rejected On": item.approved_dt || item.rejected_dt || item.cancelled_dt || "",
      "Approved / Rejected Remarks": item.approved_remarks || item.rejected_reason || item.cancelled_reason || "",
    }));
    exportEmployeeToExcel(exportData, authDetails?.unit_fullname || "Company", { address: authDetails?.unit_address || "" }, "MonthlyTimesheet_Report");
  };

  const handleExportPDF = () => {
    if (!Array.isArray(reportData) || reportData.length === 0) {
      toast.error("No data to export.");
      return;
    }
    const exportData = reportData.map((item, index) => ({
      "S.No": item.s_no || index + 1,
      "Employee Code": item.emp_no,
      "Employee Name": item.emp_name,
      "Date": item.t_date,
      "Project": `${item.client_name}${item.project}`,
      "Module": item.module_name,
      "Task": item.task_name,
      "Type": item.task_type,
      "Nature": item.task_nature,
      "Description": item.task_description,
      "Task Status": item.task_status,
      "Created By": item.create_by,
      "Created On": item.created_dt,
      "Allocated Hours": item.allocated_hours,
      "Worked Hours": typeof item.worked_hours === 'string' ? item.worked_hours.replace(/\n/g, '').trim() : item.worked_hours,
      "Approved Hours": typeof item.approved_hours === 'string' ? item.approved_hours.replace(/\n/g, '').trim() : item.approved_hours,
      "Approval Status": item.task_approval_status,
      "Approved / Rejected By": item.approved_by || item.rejected_by || item.cancelled_by || "",
      "Approved / Rejected On": item.approved_dt || item.rejected_dt || item.cancelled_dt || "",
      "Approved / Rejected Remarks": item.approved_remarks || item.rejected_reason || item.cancelled_reason || "",
    }));
    const columns = Object.keys(exportData[0]).map(key => ({ Header: key, accessor: key }));
    exportEmployeeToPDF(exportData, authDetails?.unit_fullname || "Company", { address: authDetails?.unit_address || "" }, "MonthlyTimesheet_Report", columns);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Timesheet" breadcrumbItem="Monthly Timesheet Report" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col lg={3} md={4}>
                  <Label>
                    Month <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="month"
                    value={formik.values.month}
                    onChange={val => {
                      formik.setFieldValue("month", val);
                    }}
                    onBlur={() => formik.setFieldTouched("month", true)}
                    clearable={true}
                  />
                  {formik.touched.month && formik.errors.month && (
                    <div className="text-danger mt-1">{formik.errors.month}</div>
                  )}
                </Col>

                <Col lg={3} md={4}>
                  <Label>Project</Label>
                  <Select
                    styles={SelectcustomStyles}
                    name="project"
                    options={projectOptions}
                    value={projectOptions.find(opt => opt.value === formik.values.project) || null}
                    onChange={(opt) => formik.setFieldValue("project", opt?.value || "")}
                    placeholder="Select options"
                    className="hrms-select"
                    classNamePrefix="hrms-select"
                    isClearable
                  />
                </Col>

                <Col lg={3} md={4}>
                  <Label>Employee Code</Label>
                  <Input
                    type="text"
                    name="employeeCode"
                    value={formik.values.employeeCode}
                    onChange={formik.handleChange}
                  />
                </Col>

                <Col lg={3} md={4}>
                  <Label>Client</Label>
                  <Select
                    styles={SelectcustomStyles}
                    name="client"
                    options={clientOptions}
                    value={clientOptions.find(opt => opt.value === formik.values.client) || null}
                    onChange={(opt) => formik.setFieldValue("client", opt?.value || "")}
                    placeholder="Select options"
                    className="hrms-select"
                    classNamePrefix="hrms-select"
                    isClearable
                  />
                </Col>

                <Col lg={3} md={4}>
                  <Label>Task Type</Label>
                  <Select
                    styles={SelectcustomStyles}
                    name="taskType"
                    options={taskTypeOptions}
                    value={taskTypeOptions.find(opt => opt.value === formik.values.taskType) || null}
                    onChange={(opt) => formik.setFieldValue("taskType", opt?.value || "")}
                    placeholder="Select options"
                    className="hrms-select"
                    classNamePrefix="hrms-select"
                    isClearable
                  />
                </Col>

                <Col lg={3} md={4}>
                  <Label>Task Nature</Label>
                  <Select
                    styles={SelectcustomStyles}
                    name="taskNature"
                    options={taskNatureOptions}
                    value={taskNatureOptions.find(opt => opt.value === formik.values.taskNature) || null}
                    onChange={(opt) => formik.setFieldValue("taskNature", opt?.value || "")}
                    placeholder="Select options"
                    className="hrms-select"
                    classNamePrefix="hrms-select"
                    isClearable
                  />
                </Col>

                {/* <Col lg={3} md={4}>
                  <Label>Status</Label>
                  <Select
                    styles={SelectcustomStyles}
                    name="status"
                    options={statusOptions}
                    value={statusOptions.find(opt => opt.value === formik.values.status) || null}
                    onChange={(opt) => formik.setFieldValue("status", opt?.value || "")}
                    placeholder="Select options"
                    className="hrms-select"
                    classNamePrefix="hrms-select"
                    isClearable
                  />
                </Col> */}

                <Col lg={3} md={4}>
                  <Label>App Status</Label>
                  <Select
                    styles={SelectcustomStyles}
                    name="appStatus"
                    options={appStatusOptions}
                    value={appStatusOptions.find(opt => opt.value === formik.values.appStatus) || null}
                    onChange={(opt) => formik.setFieldValue("appStatus", opt?.value || "")}
                    placeholder="Select options"
                    className="hrms-select"
                    classNamePrefix="hrms-select"
                    isClearable
                  />
                </Col>

                <Col className="d-flex align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2" disabled={loading}>
                    <i className="fas fa-search me-1" /> {loading ? 'Searching...' : 'Search'}
                  </Button>
                  <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} direction="down">
                    <DropdownToggle color="primary" className="btn button-export me-2">
                      <i className="fas fa-file-export me-1" /> Export
                    </DropdownToggle>

                    <DropdownMenu>
                      <DropdownItem onClick={handleExportExcel}>
                        <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                      </DropdownItem>

                      <DropdownItem onClick={handleExportPDF}>
                        <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <Button type="reset" onClick={() => {
                    formik.handleReset();
                    // Do not clear reportData or loading here
                  }} className="btn button-cancel">
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            {loading ? (
              <div className="text-center p-4">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading timesheet data...</p>
              </div>
            ) : reportData.length === 0 ? (
              <div className="text-center p-4">
                <p></p>
                <p></p>
              </div>
            ) : (
              <div>
                <div className="mb-2 g-2 responsive-table-row d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-2">
                    <select
                      className="form-select"
                      style={{ width: 'auto' }}
                      value={pageSize}
                      onChange={onChangeInSelect}
                    >
                      {[10, 20, 25, 50, 75, 100].map(size => (
                        <option key={size} value={size}>
                          Show {size}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <Accordion open={open} toggle={toggle} className="w-100">
                  {currentEmployees.map(([empKey, empData], empIndex) => {
                    const empTotals = calculateTotals(empData);
                    return (
                      <AccordionItem key={empKey} className="border-0 box-shadow mb-3">
                        <AccordionHeader targetId={(startIndex + empIndex).toString()} className="p-0 timesheet-acchead">
                          <div className="timesheet-summary timeaccsheet"
                            style={{ display: "grid", gridTemplateColumns: "1fr 400px 240px", alignItems: "center" }}>

                            <div>
                              <p className="mb-0">
                                <strong>{empData.employee} - {empData.empNo}</strong>
                              </p>
                            </div>
                            <div>
                              <p className="mb-0">
                                <strong>Worked Hours: <span>{empTotals.workedHours} Hrs</span></strong>
                              </p>
                            </div>
                            <div>
                              <p className="mb-0">
                                <strong>Approved Hours: <span>{empTotals.approvedHours} Hrs</span></strong>
                              </p>
                            </div>
                          </div>
                        </AccordionHeader>
                        <AccordionBody accordionId={(startIndex + empIndex).toString()}>
                          {open === (startIndex + empIndex).toString() && Object.entries(empData.dates).map(([date, dateItems]) => {
                            const dateTotals = calculateDateTotals(dateItems);
                            const dateTransformedData = dateItems.map((item, index) => {
                              const clientName = item.client_name && item.client_name !== 'null' ? item.client_name : '';
                              const projectName = item.project && item.project !== 'null' ? item.project : '';
                              const projectValue = (clientName || projectName) ? `${clientName}${projectName}` : '';

                              return {
                                sno: item.s_no || index + 1,
                                date: item.t_date,
                                project: projectValue,
                                module: item.module_name,
                                task: item.task_name,
                                type: item.task_type,
                                nature: item.task_nature,
                                description: item.task_description,
                                status: item.task_status,
                                createdBy: item.create_by,
                                createdOn: item.created_dt,
                                allocatedHours: item.allocated_hours,
                                workedHours: typeof item.worked_hours === 'string' ? item.worked_hours.replace(/\n/g, '').trim() : item.worked_hours,
                                approvedHours: typeof item.approved_hours === 'string' ? item.approved_hours.replace(/\n/g, '').trim() : item.approved_hours,
                                billable_hours: item.billable_hours || "00:00",
                                nonbillable_hours: item.nonbillable_hours || "00:00",
                                approvalStatus: item.task_approval_status,
                                approvedBy: item.approved_by || item.rejected_by || item.cancelled_by || "",
                                approvedOn: item.approved_dt || item.rejected_dt || item.cancelled_dt || "",
                                approvalRemarks: item.approved_remarks || item.rejected_reason || item.cancelled_reason || "",
                              };
                            });

                            return (
                              <div key={date} className="monthtimesheet">
                                <div className="timesheet-summary d-flex flex-wrap justify-content-between align-items-center p-2 mb-0 gap-2 hoursheet">
                                  <div>
                                    <p className="mb-0">
                                      <strong>Date: <span>{date}</span></strong>
                                    </p>
                                  </div>
                                  <div>
                                    <p className="mb-0">
                                      <strong>Worked Hours: <span>{dateTotals.workedHours} Hrs</span></strong>
                                    </p>
                                  </div>
                                  <div>
                                    <p className="mb-0">
                                      <strong>Approved Hours: <span>{dateTotals.approvedHours} Hrs</span></strong>
                                    </p>
                                  </div>
                                </div>
                                <div className="timesheet-table">
                                  <TableContainer
                                    columns={columns}
                                    data={dateTransformedData}
                                    isGlobalFilter={false}
                                    customPageSize={10}
                                    tableSorter={false}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </AccordionBody>
                      </AccordionItem>
                    );
                  })}
                </Accordion>
                <div className="align-items-center table-pagi gy-2 d-flex justify-content-between mt-3">
                  <div className="text-start text-muted">
                    Showing{" "}
                    <strong>{currentEmployees.length > 0 ? currentPage * pageSize + 1 : 0}</strong>{" "}
                    to{" "}
                    <strong>{currentPage * pageSize + currentEmployees.length}</strong>{" "}
                    of <strong>{totalEmployees}</strong> employees
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <div className="d-flex gap-1">
                      <Button color="primary" size="sm" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                        {"<<"}
                      </Button>
                      <Button color="primary" size="sm" onClick={previousPage} disabled={!canPreviousPage}>
                        {"<"}
                      </Button>
                    </div>
                    <span className="d-none d-md-block">
                      Page <strong>{currentPage + 1} of {totalPages}</strong>
                    </span>
                    <Input
                      type="number"
                      min={1}
                      style={{ width: 70 }}
                      max={totalPages}
                      defaultValue={currentPage + 1}
                      onChange={onChangeInInput}
                    />
                    <div className="d-flex gap-1">
                      <Button color="primary" size="sm" onClick={nextPage} disabled={!canNextPage}>
                        {">"}
                      </Button>
                      <Button color="primary" size="sm" onClick={() => gotoPage(totalPages - 1)} disabled={!canNextPage}>
                        {">>"}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TimesheetReportMonthlyTimesheet;

